import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';
import { useLoadReportsDependencies } from 'ProtectedRoute/useLoadReportsDependencies';
import '../locales/reports/reports-en.json';

const ReportsDirective = angularDirectiveToReact('reports', {});

export function ReportsComponent() {
    useLoadReportsDependencies();
    const [key] = useAngularToReactRoute();
    return <ReportsDirective key={key} />;
}
